export interface PostCriteriaPayload {
    provider: string;
    criteria: {
        pickupZone: {
            path: { lat: number; lng: number }[];
        };
    };
}

export interface EditCriteriaPayload {
    path: { lat: number; lng: number }[];
}

export interface PostShopifyAuthPayload {
    userId: string;
    merchantExternalId: number;
    code?: string;
    shop?: string;
    userExternalId: number;
}

export interface PostAuthPayload {
    userId: string;
    merchantExternalId: number | null;
    shop?: string;
    userExternalId: number;
}

export type PayloadEmailData = {
    email: string;
    orgName: string;
    merchant?: string;
    merchantLogo?: string;
    providerName: string;
    integrationLink: string;
    subject: string;
};
